/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Jinhyoung Jang (jangjh@rsupport.com)
 *
 * @description
 *
 * @created at Tue Mar 07 2023
 **/

export const IPCKeys = {
	Ready: "ready",
	Initialize: "initialize",
	Request: "request",
	Response: "response",
	SpaceStatus: "spaceStatus",
	ChangeSpace: "changeSpace",
	FocusStatus: "focusStatus",
	TabStatus: "TabStatus",
	RequestRenderTexture: "requestRenderTexture",
	ResponseRenderTexture: "responseRenderTexture"
};
export type IPCKeys = (typeof IPCKeys)[keyof typeof IPCKeys];

export const SceneType = {
	LauncherScene: 0,
	FittingRoomScene: 1,
	LobbyScene: 2,
	MeetingRoomScene: 3,
	MyRoomScene: 4,
	OpenWorldScene: 5,
	MyRoomEditScene: 9
};
export type SceneType = (typeof SceneType)[keyof typeof SceneType];

export const SceneLevel = {
	Empty: "",
	AvatarEdit: "AvatarEdit",
	MeetingRoom: "meeting_room_0001",
	MeetingRoom2: "meeting_room_0002",
	MeetingRoom3: "meeting_room_0003",
	MeetingRoom4: "meeting_room_0004",
	MeetingRoom5: "meeting_room_0005",
	MyRoom: "myRoom_0001",
	OpenWorldCity: "OpenWorld_0001",
	OpenWorldForest: "OpenWorld_0002",
	Lobby0001: "lobby_0001"
};
export type SceneLevel = (typeof SceneLevel)[keyof typeof SceneLevel];

export const PortalAnimationType = {
	Portal01: "portal-01"
};

export type PortalAnimationType = (typeof PortalAnimationType)[keyof typeof PortalAnimationType];

export type SceneData = {
	sceneID: string;
	sceneType: SceneType;
	sceneLevel: SceneLevel;
	animationType?: PortalAnimationType;
};
